import React, { useState, useEffect } from 'react'
import axios from 'axios'

import { useAuthContext } from "../Contexts/AuthProvider";

import ProfileEditor from './ProfileEditor';

import User from '../interfaces/User';
import { CircularProgress, Modal, Typography } from '@mui/material';

interface Props {
  userId: string;
  onClose: () => void;
}

const ProfileModal = ({ userId, onClose }: Props) => {

  const { user, setUser, fetchSubscription } = useAuthContext();

  const [userInfo, setUserInfo] = useState<User | null>(null);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState<string | null>(null);

  const isMe = user && (user.id === userId);


  useEffect(() => {
    loadUserInfo();
  }, []);

  const loadUserInfo = async () => {
    setLoading(true);

    let profileUrl = `/api/users/${userId}`;;

    try {
      const res = await axios.get<User>(profileUrl);

      if (isMe) {
        setUser(res.data);
      }

      const userDetail = { ...res.data };

      const subscription = await fetchSubscription(userDetail);

      if (subscription.length > 0) {
        userDetail.role = subscription[0].role;
      }

      setUserInfo(userDetail);
    } catch {
      setError('This user does not exist.');
    } finally {
      setLoading(false);
    }
  }

  if (error) {
    return (<Typography sx={{ width: '100%' }} fontSize='20pt' textAlign='center'>{error}</Typography>);
  }

  if (loading || !userInfo) {
    return (
      <Modal open>
        <CircularProgress sx={{
          color:'white',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }} />
      </Modal>
    )
  }

  return (
    <Modal open>
      <ProfileEditor
        userInfo={userInfo}
        onClose={() => {
          loadUserInfo();
          onClose();
        }}
      />
    </Modal>
  );
}

export default ProfileModal;
